export class CustomMessage {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                    message_type = '',
                    active = 1,
                    created_at = new Date(),
                    updated_at = new Date(),
                    deleted_at = null,
                    //relations
                    category = null,
                    template = null
                } = {}) {

        //fill attributes

        this.id = id;
        this.company_id = company_id;
        this.name = name;
        this.message_type = message_type;
        this.active = active;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        
        this.category = category;
        this.template = template;


    }

}

export function createCustomMessage(data={}) {
    return Object.freeze(new CustomMessage(data));
}